// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2jTVN","log":"ModalInventoryLogs_log__1PzGG","date":"ModalInventoryLogs_date__3fHp_","userName":"ModalInventoryLogs_userName__1xypE"};